module.exports = __webpack_public_path__ + "1792395595471/fonts/fa-brands-400.6814d0e.woff2";